import { captureException } from '@sentry/react';
import toast from 'react-hot-toast';

import { SendDocumentChannelsDialog } from '../../../customer/components/SendDocumentChannelsDialog';
import { sendInvoice } from '../../models';
import type { InvoiceDetail } from '../../endpoints/InvoiceEndpoint.types';
import { getDisplayError } from '../../../../utils/get-display-error';
import { trackEvent } from '../../../../utils/track-event';
import { runPdfJobAndRefresh } from '../../../../utils/pdf-job-client';
import { PEPPOL_ALREADY_SENT_STATUSES } from '../../../peppol/peppol.types';
import { describePeppolAlreadySent } from '../../../peppol/peppol-status-labels';

export const SendInvoiceDialog: React.FC<{
  invoice: InvoiceDetail;
  onSent?: () => Promise<void>;
}> = ({ invoice, onSent }) => {
  return (
    <SendDocumentChannelsDialog
      triggerText="Verzend factuur"
      title="Factuur versturen"
      submitText="Verzend factuur"
      customer={invoice.customer}
      peppolAlreadySent={
        PEPPOL_ALREADY_SENT_STATUSES.includes(invoice.peppol.status)
          ? describePeppolAlreadySent(invoice.peppol)
          : undefined
      }
      onSubmit={async (options) => {
        try {
          await runPdfJobAndRefresh(await sendInvoice(invoice.id, options), onSent);
          trackEvent('sale_invoice_sent', { invoice_id: invoice.id });
          toast.success('Factuur is verstuurd. Je krijgt een melding als er iets misgaat.');
        } catch (err) {
          captureException(err);
          toast.error(`Kon factuur niet versturen: ${getDisplayError(err)}`);
          throw err;
        }
      }}
    />
  );
};
